import { GeneralStatus } from 'modules/status-badge';
import { WeeksResponse, WorkPeriodsContextState } from '../../types';

export const weeksApiMock: WeeksResponse = {
  data: {
    weeks: {
      wk1: {
        calendarWeek: 19,
        calendarWeekStart: String(new Date('2023.05.08')),
        calendarWeekEnd: String(new Date('2023.05.14')),
        year: 2023,
        month: 5,
        reportedMinutes: 45,
        expectedMinutes: 600,
        weekStatus: 'NON_EXISTENT_STATUS' as GeneralStatus,
        weekAutoClosing: '',
        assignments: []
      },
      wk2: {
        calendarWeek: 20,
        calendarWeekStart: String(new Date('2023.05.15')),
        calendarWeekEnd: String(new Date('2023.05.21')),
        year: 2023,
        month: 5,
        reportedMinutes: 750,
        expectedMinutes: 800,
        weekStatus: GeneralStatus.CLOSED,
        weekAutoClosing: '',
        assignments: []
      },
      wk3: {
        calendarWeek: 21,
        calendarWeekStart: String(new Date('2023.05.22')),
        calendarWeekEnd: String(new Date('2023.05.28')),
        year: 2023,
        month: 5,
        reportedMinutes: 600,
        expectedMinutes: 600,
        weekStatus: GeneralStatus.OPEN,
        weekAutoClosing: '',
        assignments: []
      },
      wk4: {
        calendarWeek: 19,
        calendarWeekStart: String(new Date('2023.05.08')),
        calendarWeekEnd: String(new Date('2023.05.14')),
        year: 2023,
        month: 5,
        reportedMinutes: 45,
        expectedMinutes: 600,
        weekStatus: GeneralStatus.CLOSED,
        weekAutoClosing: '',
        assignments: []
      },
      wk5: {
        calendarWeek: 20,
        calendarWeekStart: String(new Date('2023.05.15')),
        calendarWeekEnd: String(new Date('2023.05.21')),
        year: 2023,
        month: 5,
        reportedMinutes: 750,
        expectedMinutes: 800,
        weekStatus: GeneralStatus.CLOSED,
        weekAutoClosing: '',
        assignments: []
      },
      wk6: {
        calendarWeek: 21,
        calendarWeekStart: String(new Date('2023.05.22')),
        calendarWeekEnd: String(new Date('2023.05.28')),
        year: 2023,
        month: 5,
        reportedMinutes: 600,
        expectedMinutes: 600,
        weekStatus: GeneralStatus.OPEN,
        weekAutoClosing: '',
        assignments: []
      }
    },
    months: [
      {
        year: 2023,
        month: 4,
        weeks: ['wk1', 'wk2', 'wk3']
      },
      {
        year: 2023,
        month: 3,
        weeks: ['wk4', 'wk5', 'wk6']
      }
    ]
  }
};

export const workPeriodsContextMock: WorkPeriodsContextState = {
  workPeriods: weeksApiMock.data,
  isLoading: false
};
